import {Component} from '@angular/core';
import {SelectSnapshot} from '@ngxs-labs/select-snapshot';
import {SalesCpiAsideState} from '../../../../../../state/sales-cpi/sales-cpi-aside.state';

@Component({
    selector: 'app-cpi-beneficiary-change-aside',
    templateUrl: './cpi-beneficiary-change-aside.component.html',
})
export class CpiBeneficiaryChangeAsideComponent {

    @SelectSnapshot(SalesCpiAsideState.step) step: number;

}
